<template>
  <div id="home" v-loading.fullscreen.lock="changeLoading">
    <div style="background-color: white; margin: 10px 20px">
      <div class="pos_container_panel" style="padding-left: 2rem">
        <!--search area-->
        <el-form :inline="true" :model="searchForm" class="demo-form-inline" style="margin-left: 6rem; padding-top: 2rem">
          <el-row>
            <el-col :span="12">
              <div class="grid-content bg-purple">
                <el-form-item label="国家">
                  <el-select default-first-option
                    filterable
                    v-model="searchForm.nation"
                    placeholder="国家"
                    style="width: 82%; margin-left: 3.5rem"
                    @change="selectNation"
                    clearable>
                    <el-option
                      v-for="item in nationoption"
                      :key="item.countryCode"
                      :label="item.countryNameLists['zh-CN']"
                      :value="item.countryCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <el-form-item label="州/省">
                  <el-select default-first-option
                    filterable
                    @change="selectProvince"
                    clearable
                    v-model="searchForm.province"
                    placeholder="州/省"
                    style="width: 87%; margin-left: 2rem">
                    <el-option
                      v-for="item in provinceoption"
                      :key="item.provinceCode"
                      :label="item.provinceNameLists['zh-CN']"
                      :value="item.provinceCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple"></div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="float: right">
              <div class="grid-content bg-purple-light" style="float: right">
                <el-button type="warning" class="harpIDbtn" @click="customSearch()">搜索</el-button>
                <el-button type="warning" class="harpIDbtn" style="margin-left: 3rem" @click="addLocation()">新增</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <hr style="margin: 1rem -14rem 0rem;background-color: rgb(241 243 245);height: 0.2rem;border: none;"/>
        <!--table-->
        <el-table :data="tableData" border style="width: 100%; margin-top: 50px; margin-left: 60px">
          <el-table-column prop="countryCode" label="国家代码" align="center"></el-table-column>
          <el-table-column prop="countryNameLists.zh-CN" label="国家名称-中文" align="center"></el-table-column>
          <el-table-column prop="countryNameLists.en" label="国家名称-英文" align="center"></el-table-column>
          <el-table-column prop="provinceCode" label="州/省代码" align="center"></el-table-column>
          <el-table-column prop="provinceNameLists.zh-CN" label="州/省名称-中文" width="140" align="center"></el-table-column>
          <el-table-column prop="provinceNameLists.en" label="州/省名称-英文" align="center"></el-table-column>
          <el-table-column label="操作" width="140" align="center">
            <template #default="scope">
              <el-button @click="handleClick(scope.row)" type="text" size="small">修改</el-button>
              <el-button type="text" size="small" @click.prevent="deleteRow(scope.row)">删除</el-button>
              <el-button v-if="scope.row.enableFlag" type="text" size="small" @click.prevent="enable(scope.row)">启用</el-button>
              <el-button v-if="scope.row.disabledFlag" type="text" size="small" @click.prevent="disabled(scope.row)">禁用</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-bottom: 1rem">
          <el-pagination
            class="paginationsty"
            background
            @current-change="handleCurrentChange"
            v-model:current-page="currentPage1"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="searchForm.total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!--新增 dialog-->
    <el-dialog title="新增州/省" v-model="dialogFormVisible">
      <el-form :model="form" ref="checkInput">
        <el-form-item
          label="国家:"
          :label-width="formLabelWidth"
          prop="countryName"
          :rules="[
            {
              required: true,
              message: '请选择国家',
              trigger: 'change',
            },
          ]"
        >
          <el-select
          default-first-option
            filterable
            style="width: 58%; margin-left: 85px"
            class="myselect_inner myicon_inner"
            v-model="form.countryName"
            placeholder="请选择"
            @change="selectNationForm"
          >
            <el-option
              v-for="item in nationoptionInit"
              :key="item.value"
              :label="item.countryName"
              :value="item.countryCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="州/省代码:"
          :label-width="formLabelWidth"
          prop="provinceCode"
          :rules="[
            {
              required: true,
              message: '请输入州/省代码',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="form.provinceCode"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="州/省-中文:"
          :label-width="formLabelWidth"
          prop="provinceCH"
          :rules="[
            {
              required: true,
              message: '请输入州/省中文名称',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="form.provinceCH"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="州/省-英文:"
          :label-width="formLabelWidth"
          prop="provinceEN"
          :rules="[
            {
              required: true,
              message: '请输入州/省英文名称',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="form.provinceEN"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="customAdd()">保存</el-button>
          <el-button @click="cancel()">取 消</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 修改dialog -->
    <el-dialog title="修改州/省" v-model="changeCityFlag">
      <el-form :model="changeForm" ref="checkInput">
        <el-form-item label="国家:" :label-width="formLabelWidth">
          <el-select
            disabled
            style="width: 58%; margin-left: 85px"
            class="myselect_inner myicon_inner"
            v-model="changeForm.countryName"
            placeholder="请选择"
          >
            <el-option
              v-for="item in nationoption"
              :key="item.value"
              :label="item.countryName"
              :value="item.countryCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="州/省代码:"
          :label-width="formLabelWidth"
          prop="provinceCode"
          :rules="[
            {
              required: true,
              message: '请输入州/省代码',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            disabled
            v-model="changeForm.provinceCode"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="州/省-中文:"
          :label-width="formLabelWidth"
          prop="provinceCH"
          :rules="[
            {
              required: true,
              message: '请输入州/省中文名称',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="changeForm.provinceCH"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="州/省-英文:"
          :label-width="formLabelWidth"
          prop="provinceEN"
          :rules="[
            {
              required: true,
              message: '请输入州/省英文名称',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="changeForm.provinceEN"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="changeSave()">保存</el-button>
          <el-button @click="cancel()">取 消</el-button>
        </span>
      </template>
    </el-dialog>
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
    <el-dialog title="警告" v-model="dialogVisible" width="30%" >
      <span>将删除该省份以及城市所有信息，请确认是否删除</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="confirmDelete">确 定</el-button>
          <el-button @click="cancelDelete">取 消</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  getcountryList,
  getprovinceList,
  saveprovinceList,
  deleteprovinceList,
  buttonEnable,
} from "@/api/shoppingData";
import ConfirmBoxs from "@/components/confirmBoxs.vue";

export default {
  name: "HBEProvince",
  components: {
    ConfirmBoxs,
  },
  data() {
    return {
      dialogVisible: false,
      changeLoading: false,
      defaultNameCH: "",
      defaultNameEN: "",
      changeRow: "",
      currentPage1: 1,
      confirmIcon: "",
      deleteFlag: false,
      confirmFlag: false,
      confirmMsg: "",
      dialogFormVisible: false,
      changeCityFlag: false,
      addCountryCode: "",
      form: {
        countryName: "",
        countryCode: "",
        provinceCode: "",
        provinceName: "",
        nationCH: "",
        nationEN: "",
        provinceCH: "",
        provinceEN: "",
      },
      changeForm: {
        countryName: "",
        countryCode: "",
        provinceCode: "",
        provinceName: "",
        nationCH: "",
        nationEN: "",
        provinceCH: "",
        provinceEN: "",
        id: "",
      },
      //
      formLabelWidth: "150px",
      selecttype: 0,
      selectnation: "",
      nationoptionInit: "",
      selectnationForm: "",
      selectprovince: "",
      locationCode: "",
      paramsCitycode: "",
      citycode: "",
      cityCode: "",
      clickRow: {},
      tableData: [],
      searchForm: {
        nation: "",
        province: "",
        city: "",
        nameEN: "", //位置名称
        total: null,
      },
      cityoption: [],
      nationoption: [],
      provinceoption: [],
    };
  },
  mounted() {
    this.getCountryList();
  },
  methods: {
    //分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.customSearch(val);
      console.log(`当前页: ${val}`);
    },
    enable(data) {
      let getParams = {
        params: {
          type: 1,
          code: data.provinceCode,
          action: 1,
        },
      };
      console.log(getParams, "getParams");
      this.getBtnDisplay(getParams);
      // this.customSearch();
    },
    disabled(data) {
      let getParams = {
        params: {
          type: 1,
          code: data.provinceCode,
          action: 0,
        },
      };
      console.log(getParams, "getParams");
      this.getBtnDisplay(getParams);
    },
    async getBtnDisplay(getParams) {
      this.changeLoading = true;
      console.log(getParams, "传参");
      await buttonEnable(getParams).then((res) => {
        if (res.code === 200) {
          this.changeLoading = false;
           this.customSearch();
          console.log(res, "res====>");
        }
      });
    },
    //国省市change事件
    selectNation(value) {
      (this.searchForm.province = ""), (this.selectnation = value);
      if (value) {
        this.getProvinceList(value);
      }
    },
    selectProvince(value) {
      this.selectprovince = value;
      console.log(this.selectprovince, " this.selectprovince");
    },
    //新增from国家change事件
    selectNationForm(value) {
      this.addCountryCode = value;
      this.form.nationCH = "";
      this.form.nationEN = "";
    },
    //获取搜索下拉值-国省市
    async getCountryList() {
      this.changeLoading = true;
      let searchparams = {
        params: {
          countryCode: "",
        },
      };
      await getcountryList(searchparams)
        .then((res) => {
          if (res.code === 200) {
            this.changeLoading = false;
            this.nationoption = res.data.list;
            console.log(this.nationoption, " this.nationoption");
            console.log("获取国家下拉值", res.data.list);
          } else {
            this.changeLoading = false;
          }
        })
        .catch(function (error) {
          console.log("国家下拉值 请求失败", error.objError);
        });
    },
    // 新增form下拉框选中事件
    async getCountryListInit() {
      this.changeLoading = true;
      let searchparams = {
        params: {
          countryCode: "",
        },
      };
      await getcountryList(searchparams)
        .then((res) => {
          if (res.code === 200) {
            this.changeLoading = false;
            this.nationoptionInit = res.data.list;
            console.log("获取国家下拉值", res.data.list);
          } else {
            this.changeLoading = false;
          }
        })
        .catch(function (error) {
          console.log("国家下拉值 请求失败", error.objError);
        });
    },
    async getProvinceList(value) {
      this.changeLoading = true;
      let searchparams = {
        params: {
          countryCode: value,
          provinceCode: "", //?
        },
      };
      await getprovinceList(searchparams)
        .then((res) => {
          if (res.code === 200) {
            this.changeLoading = false;
            this.provinceoption = res.data.list;
            console.log("获取省下拉值", res.data.list);
          } else {
            this.changeLoading = false;
          }
        })
        .catch(function (error) {
          console.log("省下拉值 请求失败", error.objError);
        });
    },
    // 新增button
    addLocation() {
      this.dialogFormVisible = true;
      this.getCountryListInit();
    },
    //新增保存
    async customAdd() {
      this.$refs["checkInput"].validate((valid) => {
        if (valid) {
          this.changeLoading = true;
          let saveParams = {
            countryCode: this.addCountryCode,
            provinceCode: this.form.provinceCode,
            provinceName: this.form.provinceCH,
            provinceNameLists: [
              {
                languageCode: "zh-CN",
                name: this.form.provinceCH,
                description: "",
              },
              {
                languageCode: "en",
                name: this.form.provinceEN,
                description: "",
              },
            ],
          };
          console.log(saveParams, "保存参数");
          this.saveNew(saveParams);
          this.$refs.checkInput.clearValidate();
          this.dialogFormVisible = false;
        }
      });
    },
    async saveNew(saveParams) {
      await saveprovinceList(saveParams)
        .then((res) => {
          if (res.code === 200) {
            this.$refs.checkInput.resetFields();
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "新增成功";
            this.deleteFlag = false;
            this.getProvinceList(this.selectnation);
            this.customSearch();
          } else {
            this.$refs.checkInput.resetFields();
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "新增失败";
            this.deleteFlag = false;
            this.customSearch();
          }
        })
        .catch(function (error) {
          this.$refs.checkInput.resetFields();
          this.changeLoading = false;
          console.log("新增失败", error.objError);
          this.customSearch();
        });
    },
    //修改button
    handleClick(row) {
      this.changeRow = row;
      this.changeCityFlag = true;
      this.changeForm.countryName = this.changeRow.countryNameLists["zh-CN"];
      this.changeForm.countryCode = this.changeRow.countryCode;
      this.changeForm.nationEN = this.changeRow.countryNameLists["en"];
      this.changeForm.nationCH = this.changeRow.countryNameLists["zh-CN"];
      this.changeForm.provinceCode = this.changeRow.provinceCode;
      this.changeForm.provinceCH = this.changeRow.provinceNameLists["zh-CN"];
      this.changeForm.provinceEN = this.changeRow.provinceNameLists["en"];
      this.changeForm.id = this.changeRow.provinceId;
      console.log(row, "row");
    },
    // 修改保存
    async changeSave() {
      this.$refs["checkInput"].validate((valid) => {
        if (valid) {
          this.changeLoading = true;
          let saveParams = {
            countryCode: this.changeForm.countryCode,
            provinceCode: this.changeForm.provinceCode,
            provinceName: this.changeForm.provinceCH,
            id: this.changeForm.id,
            provinceNameLists: [
              {
                languageCode: "zh-CN",
                name: this.changeForm.provinceCH,
                description: "",
              },
              {
                languageCode: "en",
                name: this.changeForm.provinceEN,
                description: "",
              },
            ],
          };
          console.log(saveParams, "修改保存参数");
          this.saveChange(saveParams);
          this.changeCityFlag = false;
        }
      });
    },
    async saveChange(saveParams) {
      await saveprovinceList(saveParams)
        .then((res) => {
          if (res.code === 200) {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "修改成功";
            this.deleteFlag = false;
            this.getProvinceList(this.selectnation);
            this.customSearch();
          } else {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "修改失败";
            this.deleteFlag = false;
            this.customSearch();
          }
        })
        .catch(function (error) {
          this.changeLoading = false;
          console.log("修改失败", error.objError);
          this.customSearch();
        });
    },
    //取消button
    cancel() {
      this.$refs.checkInput.resetFields();
      this.dialogFormVisible = false;
      this.changeCityFlag = false;
    },
    //删除
    async deleteRow(row) {
      this.dialogVisible = true;
      this.deleteparams = {
        params: {
          provinceCode: row.provinceCode,
        },
      };
    },
    cancelDelete() {
      this.dialogVisible = false;
    },
    confirmDelete() {
      this.dialogVisible = false;
      deleteprovinceList(this.deleteparams)
        .then((res) => {
          if (res.code === 200) {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "删除成功";
            this.deleteFlag = false;
            this.customSearch();
          } else {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "删除失败";
            this.deleteFlag = false;
            this.customSearch();
          }
        })
        .catch(() => {
          this.changeLoading = false;
          this.confirmFlag = true;
          this.confirmMsg = "删除失败";
          this.deleteFlag = false;
          this.customSearch();
        });
    },
    //搜索button
    async customSearch(int) {
      this.changeLoading = true;
      let searchparams = {
        params: {
          countryCode: this.selectnation,
          provinceCode: this.selectprovince,
          page: int ? int : 1,
          per_page: 10,
        },
      };
      await getprovinceList(searchparams)
        .then((res) => {
          if (res.code === 200) {
            res.data.list.map((item) => {
              if (item.isEnable === 1) {
                item.enableFlag = false;
                item.disabledFlag = true;
              } else if (item.isEnable === 0) {
                item.enableFlag = true;
                item.disabledFlag = false;
              }
              return item;
            });
            this.currentPage1 = res.data.pageNumber;
            this.changeLoading = false;
            this.tableData = res.data.list;
            this.searchForm.total = res.data.total;
          } else {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "搜索省份信息失败，请稍后重试";
            this.deleteFlag = false;
          }
        })
        .catch(function (error) {
          console.log("省份数据 请求失败", error.objError);
        });
    },
    setConfirmFlag(value) {
      this.changeLoading = false;
      this.confirmFlag = value;
    },
  },
};
</script>

<style scoped>
.loading {
  z-index: 9999999;
}
.paginationsty {
  float: right;
  margin: 1rem 0;
}
.pos_container_panel {
  padding: 0 16rem 4rem;
}
.harpIDbtn {
  width: 10rem;
  height: 3rem;
  padding: 0 !important;
  font-size: 1rem !important;
}
</style>
